export default __webpack_public_path__ + "static/media/x20.96f20ad1.png";